export enum EmployeeListPermissions {
  employeeListRankings = 'employeeListRankings',
  employeeListInvite = 'employeeListInvite',
  employeeSearch = 'employeeSearch',
  employeeSearchResults = 'employeeSearchResults',
  chatbotUser = 'chatbotUser',
}
